/**
 * There's two ways to specify an href to make the whole block clickable using that href:
 * 1. In "components" prop (for CTA button/link) if there's a link it will pick up that link
 * 2. In "blurb" prop (wysiwyg content) if there's a link it will pick up that link
 */

import React, { Component } from "react"
import PropTypes from "prop-types"
import { childParser } from "containers/utilities"
import { WINDOW } from "constants/environment"
import bowser from "bowser"
import { Space, H5, Interactive, Content } from 'AtomicComponents'

/** Render a tout block with icon */
class IconToutBlock extends Component {
  constructor(props) {
    super(props)
    this.state = {
      href: null
    }
  }
  static propTypes = {
    preHeading: PropTypes.string,
    heading: PropTypes.string,
    blurb: PropTypes.string,
    imageSrc: PropTypes.string.isRequired,
    imageAlt: PropTypes.string,
    components: PropTypes.array,
    gtm: PropTypes.object
  }
  componentDidMount() {
    const { blurb, components } = this.props
    // If there's a link in wysiwyg, get the first link and put it in state
    if (Array.isArray(components) && components[0].props) {
      this.setState({ href: components[0].props.href })
    } else if (blurb.includes("<a href=")) {
      const matchHref = blurb.match(/<a href="(.*?)"/)
      this.setState({ href: matchHref[1] })
    }
  }
  handleClick = () => {
    const { href } = this.state
    if (href) {
      if (bowser.ios) {
        setTimeout(() => {
          WINDOW.location.href = href
        }, 300)
      } else {
        WINDOW.location.href = href
      }
    }
  }
  /**
   * @param {String} [preHeading] - preheading text.
   * @param {String} heading - heading text.
   * @param {String} imageSrc - Icon image src url.
   * @param {String} [imageAlt] - Icom alt text.
   * @param {String} [blurb] - blurb content to render as html.
   * @returns {ReactElement} React Component
   */
  render() {
    const {
      imageAlt, imageSrc, preHeading, heading, blurb, components, gtm, textAlign
    } = this.props
    const { href } = this.state
    const isClickable = !!href
    return (
      <div style={styles.base(isClickable, textAlign)} onClick={() => this.handleClick()}>
        <div>
          <img style={styles.img} src={imageSrc} alt={imageAlt} />
          {
            preHeading &&
            <div>
              <Interactive>
                {preHeading}
              </Interactive>
              <Space />
            </div>
          }
          <H5 withDetails>{heading}</H5>
          {blurb && <Content xmlString={blurb} />}
        </div>
        <div>
          {childParser(this.props, index => ({
            gtm: {
              category: gtm.category,
              action: `${gtm.action} - "${heading}" - Clicked "${components[index].props.text}"`
            }
          }))}
        </div>
        <Space />
      </div>
    )
  }
}

export default IconToutBlock

const styles = {
  base: (isClickable,textAlign) => ({
    margin: "0 auto",
    textAlign: !textAlign ? "center" : textAlign,
    display: "flex",
    width: '80%',
    flexDirection: "column",
    justifyContent: "space-between",
    cursor: isClickable && "pointer"
  }),
  img: {
    height: "10em",
    width: "auto"
  }
}



// WEBPACK FOOTER //
// ./src/containers/icon-tout-block/index.jsx